// extracted by mini-css-extract-plugin
export default {"search":"styles_search__2H87R","search_component":"styles_search_component__27DBk","search_input":"styles_search_input__2C-QN","search_trigger":"styles_search_trigger__SyxLm"};